import axiosInstance from 'helpers/axiosInstance';

interface StreamChatAuthResponse {
  token: string;
}

export const streamChatAuth = () => {
  const url = '/stream_chat/auth';

  return axiosInstance
    .get<StreamChatAuthResponse>(url)
    .then(r => r.data.token)
    .catch(err => err);
};
